export default __webpack_public_path__ + "static/media/bojo_xl.68019656.jpg";